// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { constructFrom as fn } from "../constructFrom.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const constructFrom = convertToFP(fn, 2);

// Fallback for modularized imports:
export default constructFrom;
